
<template>
  <div class="font app-content isVisitor bg-blue" >
    <b-container class='mt-4 px-0'>
      <b-row>
        <b-col cols='10' class='mx-auto px-0'>
          <b-row>
            <a href="/job_mypage" class='text-orange'>＜ TOPに戻る</a>
          </b-row>
          <b-row class='mt-4 border-bottom pb-2'>
            <b-col cols="12" class='px-0'>
              <h4 class="org_title">使い方ガイド</h4>
            </b-col>
          </b-row>
          <div>
            <b-row>
                <h5 class="mx-auto pt-3 pb-3">現在作成中です</h5>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>

export default {
  components: {
  },
  data() {
    return{
      idToken: localStorage.idToken,
    }
  },
  methods: {
  },
  mounted(){
    this.$store.commit('setLoading', false)
  }
}

</script>

<style scoped lang="scss">
</style>
